import styled from 'styled-components';
import Image from '../../Images/Greeter/bg-2.jpg';

export const GalleryContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const GalleryWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const GalleryWhiteWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
padding: 50px 25px;
background: #fff;
border-radius: 25px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
`;

export const GalleryDetailsTop = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 200px;
background: linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2) ), url(${Image});
background-repeat: no-repeat;
background-size: cover;
justify-content: center;
margin-bottom: 25px;
`;

export const GalleryTopHeader = styled.h1`
font-size: 36px;
color: #fff;
font-weight: bold;
text-align: center;

@media screen and (max-width: 768px){
    font-size: 28px;
}

@media screen and (max-width: 480px){
    font-size: 24px;
}
`;

export const InfoRow = styled.div`
display: grid;
grid-auto-columns: minmax(auto, 1fr);
grid-template-areas: ${({ imgStart }) => (imgStart ? '\'col2\''`'col1'` : '\'col1 col2\'')};

@media screen and (max-width: 980px){
    grid-template-areas: ${({ imgStart }) => (imgStart ? '\'col1\' \'col2\'' : '\'col1 col1\' \'col2 col2\'')};
}
`;

export const Column1 = styled.div`
display: flex;
flex-direction: column;
margin-bottom: 15px;
padding: 0 15px;
grid-area: col1;
`;

export const Column2 = styled.div`
display: flex;
margin-bottom: 15px;
padding: 0 15px;
grid-area: col2;
`;

export const GalleryNftImage = styled.img`
width: 100%;
max-width: 500px;
height: auto;
border-radius: 10px;
`;

export const DetailsWrapper = styled.div`
display: flex;
flex-direction: column;
`;

export const DetailsSmallHeader = styled.h3`
font-size: 36px;
color: #000;
font-weight: bold;
margin-bottom: 25px;

@media screen and (max-width: 768px){
    font-size: 28px;
}

@media screen and (max-width: 480px){
    font-size: 24px;
}
`;

export const DetailsText = styled.p`
font-size: 18px;
color: #000;

@media screen and (max-width: 768px){
    font-size: 16px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
    inline-size: 250px;
    overflow-wrap: break-word;
}

> span{
    font-weight: bold;
}
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
background: #D3D3D3;
margin-top: 5px;
margin-bottom: 5px;
`;

export const Divider2 = styled.div`
width: 100%;
height: 1px;
background: #D3D3D3;
margin-top: 20px;
margin-bottom: 20px;
`;

export const ErrorWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`;

export const ErrorHeader = styled.h3`
font-size: 24px;
color: #000;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;

export const ErrorText = styled.p`
font-size: 18px;
color: #000;

@media screen and (max-width: 768px){
    font-size: 16px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
}
`;

export const Timetext = styled.p`
font-size: 18px;
color: #000;
font-weight: bold;
margin-top: 10px;

@media screen and (max-width: 768px){
    font-size: 16px;
    text-align: center;
    margin-bottom: 25px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
    text-align: center;
    margin-bottom: 25px;
}
`;
